import React from 'react';

import MoreLink from 'components/MoreLink';
import { RoutePath } from 'enums/Routes';
import { useNavigate } from 'hooks/useNavigate';
import useOpenShiftImpactChat from 'hooks/useOpenShiftImpactChat';
import ShiftsList from 'components/FinancialCheckup/ShiftsList';

import AISuggestionCard from './AISuggestionCard';
import { useAvailableShifts } from './useAvailableShifts';

import styles from './AvailableShiftsSection.module.scss';

const MAX_DISPLAYED_SHIFTS = 2;
const NAVIGATE_TO_ALL_SHIFTS_EVENT = 'navigate_to_all_shifts';
const AI_SUGGESTION_CLICKED_EVENT = 'ai_suggestion_clicked';

const AvailableShiftsSection: React.FC = () => {
  const { shifts, goalMessage, goalDescription } = useAvailableShifts();
  const navigate = useNavigate();
  const openShiftImpactChat = useOpenShiftImpactChat();

  if (!shifts || shifts.length === 0) return null;

  const displayShifts = shifts.slice(0, MAX_DISPLAYED_SHIFTS);
  const featuredShift = displayShifts[0];

  const handleSeeAll = () => {
    analytics.track(NAVIGATE_TO_ALL_SHIFTS_EVENT);
    navigate(RoutePath.AvailableShifts);
  };

  const handleAISuggestionClick = () => {
    // Sanity check
    if (!featuredShift) return;

    analytics.track(AI_SUGGESTION_CLICKED_EVENT, { shift_id: featuredShift.id });
    openShiftImpactChat({ shiftId: featuredShift.shiftId });
  };

  const showMoreLink = shifts.length > MAX_DISPLAYED_SHIFTS;

  return (
    <div className={styles.availableShiftsSection}>
      <div className={styles.labelContainer}>
        <p className={styles.sectionLabel}>Available shifts</p>
        {showMoreLink && <MoreLink onClick={handleSeeAll} />}
      </div>

      <AISuggestionCard title={goalMessage} description={goalDescription} onClick={handleAISuggestionClick} />
      <ShiftsList shifts={displayShifts} />
    </div>
  );
};

export default AvailableShiftsSection;
